import React from 'react';
import './Products.css';

import { Heading, Product } from '../../../components';
import { productsContent } from '../../../constants';


const Products = () => {

  const featuredProductIds = [7, 1, 2, 3, 4, 5, 6, 8];
  const topProducts = featuredProductIds
    .map((id) => productsContent.find((product) => product.id === id))
    .filter(Boolean);

  return (
    <section className='products'>

      {/* Section heading */}
      <Heading title={'featured products'} />

      <div className='box-container'>
        {
          // Map over the top products array to render each product
          topProducts.map((item) => {
            return (
              <Product key={item.id} product={item} />
            )
          })
        }
      </div>
    </section>
  )

}

export default Products;
